import { inject, injectable } from 'inversify';
import type { AbstractCockpitApiErrorDataTransformer } from '@shared/common/error/data/transformer/abstract-cockpit-error.api-data-transformer';
import { ErrorDependencyTypes } from '@shared/common/error/error.dependency-types';
import type { ConstraintValidationApiErrorDataTransformer } from '@shared/common/error/data/transformer/constraint-validation-error.api-data-transformer';
import type { UnknownApiErrorDataTransformer } from '@shared/common/error/data/transformer/unknown-error.api-data-transformer';

@injectable()
export class CockpitApiErrorDataTransformerLocator {
  public constructor(
    @inject(ErrorDependencyTypes.ConstraintValidationApiErrorDataTransformer)
    private readonly constraintValidationApiErrorDataTransformer: ConstraintValidationApiErrorDataTransformer,
    @inject(ErrorDependencyTypes.UnknownApiErrorDataTransformer)
    private readonly unknownApiErrorDataTransformer: UnknownApiErrorDataTransformer,
  ) {}

  public find(status: number): AbstractCockpitApiErrorDataTransformer {
    if (status === 422) {
      return this.constraintValidationApiErrorDataTransformer;
    }

    return this.unknownApiErrorDataTransformer;
  }
}
